import { render, staticRenderFns } from "./StartSave.vue?vue&type=template&id=2ca43bfa&scoped=true"
import script from "./StartSave.vue?vue&type=script&lang=js"
export * from "./StartSave.vue?vue&type=script&lang=js"
import style0 from "./StartSave.vue?vue&type=style&index=0&id=2ca43bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca43bfa",
  null
  
)

export default component.exports